'use strict'

export default typeof Blob !== 'undefined' ? Blob : null



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/browser/classes/Blob.js
// module id = 335
// module chunks = 14